import axios from '@/libs/axios'

export class DeviceService {


  static get URL() {
    return 'devices'
  }


  static async getDeviceById(id) {
    try {
      const response = await axios.get(`${this.URL}/${id}`)
      return response.data.device
    }

    catch (error) {
      return error.response.data ? error.response.data.error : error.response.statusText
    }
  }


  static async createDevice(data) {
    return new Promise((resolve, reject) => {
      axios.post(`devices`, data)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async updateDevice(id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`devices/${id}`, data)
        .then(res => resolve(res.data.device))
        .catch(reason => reject(reason.response))
    })
  }



  static async deleteDevice(id) {
    return new Promise((resolve, reject) => {
      axios.delete(`${this.URL}/${id}`)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }

  static async vehicleRegister(data){
    return new Promise((resolve, reject) => {
      axios.post(`wasl`, data)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }

}
